import { PayloadAction } from '@reduxjs/toolkit';

/*eslint-disable no-unused-vars */

export default function getReducersLayout<T>(initialState: T): {
    setData: (state: T, action: PayloadAction<Partial<T>>) => void;
    resetData: (state: T, _action: PayloadAction<null>) => void;
} {
    return {
        setData: (state: T, action: PayloadAction<Partial<T>>) => {
            return { ...state, ...action.payload };
        },
        resetData: (state: T, _action: PayloadAction<null>) => {
            state = Object.assign(state, initialState);
        },
    };
}
